export default __webpack_public_path__ + "static/media/Engage_Logo.bca276e9.svg";